import { ensureNotFalsy as e, promiseWait as t, PROMISE_RESOLVE_VOID as r, RxStorageDefaultStatics as o } from "rxdb-old2";
import { createIndexesOnStore as n } from "./indexeddb-index-helpers";
export var INDEXEDDB_DOCS_STORE_SUFFIX = "documents";
export var INDEXEDDB_DOCS_STORE_ATTACHMENTS_SUFFIX = "attachments";
export var TRANSACTION_SETTINGS = {
  durability: "relaxed"
};
export var RX_STORAGE_NAME_INDEXEDDB = "indexeddb";
export var RxStorageIndexedDBStatics = o;
var a = 0;
export function attachmentObjectId(e, t) {
  return e + "||" + t;
}
var s = new Map();
function c(t, o) {
  var n = s.get(t);
  return n || (n = r), n = e(n).then(() => o()), s.set(t, n), n;
}
function i(e, r, o) {
  var n = a++,
    s = o.indexedDB,
    i = async () => (await t(0), c(e, () => new Promise((t, r) => {
      var o = s.open(e);
      o.onerror = function (t) {
        console.error(n + ": OPEN IDB DATABASE " + e + " ERROR"), r(t);
      }, o.onsuccess = function (e) {
        var r = o.result;
        t(r), d(u, r);
      }, addStoresDuringOnUpgradeNeeded(u, o);
    }))),
    u = {
      debugId: n,
      closed: !1,
      storage: r,
      settings: o,
      refreshIDBDatabase: i,
      creationPromise: i(),
      name: e,
      refCount: 0,
      storesToOpen: []
    };
  return u;
}
function d(e, t) {
  t.onversionchange = r => {
    e.closed || (t.close(), e.creationPromise = e.refreshIDBDatabase());
  };
}
export function getIndexedDBState(t, r, o, n) {
  var a = t.indexedDBStates.get(o);
  return a || (a = i(o, t, r), t.indexedDBStates.set(o, a)), a.storesToOpen = a.storesToOpen.concat(n), a.refCount = a.refCount + 1, a.creationPromise.then(() => openStoresOnExistingDatabase(e(a))).then(() => e(a));
}
var u = 0;
export function getDatabaseAddStoresCount() {
  return u;
}
export async function openStoresOnExistingDatabase(e) {
  var t = e.settings.indexedDB;
  if (0 !== e.storesToOpen.length) return e.creationPromise = e.creationPromise.then(async r => {
    var o = new Set(Array.from(r.objectStoreNames));
    if (0 === e.storesToOpen.filter(e => !o.has(getStoreNamesForStorageInstance(e.collectionName, e.schema).documentStore)).length) return r;
    u += 1;
    var n = r.version + 1;
    return r.close(), c(e.name, () => new Promise(async (r, o) => {
      var a = t.open(e.name, n);
      a.onerror = function (t) {
        console.error(e.debugId + ": ERROR openStoresOnExistingDatabase() openRequest: error "), o(t);
      }, a.onsuccess = function (t) {
        var o = a.result;
        d(e, o), r(o);
      }, a.onblocked = e => {}, addStoresDuringOnUpgradeNeeded(e, a);
    }));
  }), e.creationPromise;
}
export function getStoreNamesForStorageInstance(e, t) {
  var r = t.version;
  return {
    documentStore: e + "-" + r + "-" + INDEXEDDB_DOCS_STORE_SUFFIX,
    attachmentsStore: e + "-" + r + "-" + INDEXEDDB_DOCS_STORE_ATTACHMENTS_SUFFIX
  };
}
export function addStoresDuringOnUpgradeNeeded(e, t) {
  t.onupgradeneeded = function (r) {
    var o = t.result;
    e.storesToOpen.forEach(e => {
      var t = o.objectStoreNames,
        r = getStoreNamesForStorageInstance(e.collectionName, e.schema);
      if (!t.contains(r.documentStore)) {
        var a = o.createObjectStore(r.documentStore, {
          keyPath: "i",
          autoIncrement: !1
        });
        n(a, e), e.schema.attachments && o.createObjectStore(r.attachmentsStore, {
          keyPath: "docIdWithAttachmentId",
          autoIncrement: !1
        });
      }
    }), e.storesToOpen = [];
  };
}
export async function closeIndexedDBDatabase(e) {
  if (!e.closed && (e.refCount = e.refCount - 1, 0 === e.refCount)) return e.closed = !0, e.storage.indexedDBStates.delete(e.name), e.creationPromise.then(e => e.close());
}
export async function awaitCreationPromise(e) {
  for (;;) {
    var t = e.creationPromise;
    if (await e.creationPromise, t === e.creationPromise) return e.creationPromise;
  }
}